import angular from 'angular';
import template from './postaladdress.html';
import PostaladdressComponent from './postaladdress.component';

const postaladdressConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('postaladdress', {
		title: 'Postal Address',
		group: 'advanced',
		/**
		 * @param {any} data
		 * @returns {string}
		 */
		tableView(data) {
			return data ? data.name : '';
		},
		template,
		views:      [
			{
				name:     'Display',
				template: 'kform/components/postal-address/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		children:   false,
		selectable: true,
		settings:   new PostaladdressComponent(),
		icon:       'fa fa-map-marker',
	});
};

export default angular.module('app')
	.config(postaladdressConfig);
